import {api} from '@/api/setup';
import {IArtistJson} from "../../../server/src/modules/shared-interfaces";
import {cacheOrFetch} from "@/api/cache";



export async function getAll(): Promise<IArtistJson[]> {
    const data: IArtistJson[] = await cacheOrFetch(api('/artists'));
    return data;
}

export async function getById(id: number): Promise<IArtistJson> {
    const data: IArtistJson =  await cacheOrFetch(api(`/artists/${id}`));
    return data;
}
